<template>
  <div class='my-order-personal'>
    <sub-nav :navs='navs' />
    <h2>选择退款订单</h2>
    <div class='content'>
      <div v-loading='loading' class='table-wrapper'>
        <!-- 列表 团体订单-->
        <table class='table'>
          <thead>
            <tr>
              <td v-for='item in tables' :style='{width:item.width}' :key='item.idx' >{{ item.label }}</td>
            </tr>
          </thead>
          <tbody v-if='list.length'>
            <tr v-for='item in list' :key='item.idx'>
              <td v-for='t in tables' :key='t.idx' :style='{width:item.width}'>
                <div v-if='t.props === "apply_refund"' class='cell'>
                  <a v-if='item.status === 1' href='javascript:;' @click='apply2Refund(item)'>申请退款</a>
                </div>
                <div v-else class='cell'>{{ item[t.props] | propsFilter(t.props) }}</div>
              </td>
            </tr>
          </tbody>
          <p v-else class='no-data'>无数据</p>
        </table>
      </div>
      <div class='btn-wrapper'>
        <a href='javascript:;' @click='goBack'>返回</a>
      </div>
    </div>
  </div>
</template>

<script>
import SubNav from '@/components/SubNav'

import { PERSONAL_ORDER_DETAIL } from '@/api'

export default {
  components: {
    SubNav
  },
  filters: {
    propsFilter(val,props) {
      let result
      switch (props) {
        case 'discount':
          result = val + '%'
          break
        default:
          result = val
      }
      return result
    }
  },
  data() {
    return {
      navs: [{label: '个人中心', path: '/my'},{label: '我的订单',path: '/myorder/person_all'}],
      loading: false,
      tables: [    
        { idx: 1, label: '序号', props: 'idx', width: '50px'},
        { idx: 8, label: '批发单号', props: 'wholesale_no', width: '120px'},
        { idx: 10, label: '书名', props: 'book_name',width: '220px'},
        { idx: 9, label: '书号', props: 'book_no', width: '150px'},
        { idx: 15, label: '索引', props: 'indexes',width: '60px'},
        { idx: 3, label: '学校', props: 'school', width: '100px'},
        { idx: 4, label: '院系', props: 'department', width: '120px'},
        { idx: 5, label: '年级专业班级', props: 'profession_class',width: '120px'},
        { idx: 12, label: '价格', props: 'price',width: '80px'},
        { idx: 13, label: '折扣', props: 'discount',width: '70px'},
        { idx: 14, label: '数量', props: 'pay_num',width: '50px'},
        { idx: 16, label: '付款状态', props: 'statusTxt',width: '120px'},      // 状态 1:已付款， 2：退款审核中; 3:退款完成; 4:退款拒绝, 5:已配货, 6:退款审核通过，退款中
        { idx: 17, label: '申请退款', props: 'apply_refund',width: '120px'},
      ],
      list: []
    }
  },
  created() {
    this.getOrder()
  },
  methods: {
    // 申请退款-团体
    apply2Refund(order) {
      this.$store.commit('setRefundOrder',order)
      this.goRouter('/apply2refund')
    },

    getOrder() {
      if (!this.$store.state.payOrderNo) this.goBack()
      else this.getList()
    },

    // 获取列表
    getList() {
      let para = {
        pay_order_no: this.$store.state.payOrderNo
      }
      this.loading = true
      PERSONAL_ORDER_DETAIL(para).then(res=>{
        this.loading = false
        if (res.data.code === 0) {
          this._formatList(res.data.data)
        }
      })
    },

    // 格式化列表
    _formatList(data) {
      this.list = []
      data.forEach((e,idx)=>{
        e.idx = idx + 1
        e.statusTxt = this._formatStatus(e.status)
        this.list.push(e)
      })
    },

    // 格式化订单状态
    _formatStatus(status) {
      let txt
      switch (status) {
        case 1:
          txt = '已付款'
          break
        case 2:
          txt = '退款审核中'
          break
        case 3:
          txt = '退款完成'
          break
        case 4:
          txt = '拒绝退款'
          break
        case 5:
          txt = '已配货'
          break
        case 6:
          txt = '审核通过，退款中'
          break
        default:
          txt = ''
          break
      }
      return txt
    },
  }
}
</script>
<style lang="less" scoped>
@import "../assets/css/mixin.less";
.my-order-personal {
  width: 1200px;

  h2 {
    text-align: center;
    font-size: 20px;
    color: #000;
    font-weight: 500;
  }
  .content {
    width: 1200px;
    position: relative;
    margin-top: 30px;

    .table-wrapper {
      width: 1200px;
      overflow-x: scroll;
      position: relative;

      .table {
        width: 1500px;
        table-layout: fixed;
        border: 1px solid #999;
        font-size: 14px;
        text-align: center;

        tbody,
        thead {
          td {
            height: 40px;
            vertical-align: middle;
            box-sizing: border-box;
            border-bottom: 1px solid #dddddd;
            border-right: 1px solid #dddddd;
          }
        }

        thead td {
          background-color: @blue-d;
          color: #ffffff;
        }
        tbody {
          tr:nth-of-type(even) {
            background-color: @blue-l;
          }

          td {
            color: #4d4d4d;
          }

          a {
            font-size: 12px;
            color: @blue-d;
            display: inline-block;
            width: 84px;
            height: 25px;
            line-height: 25px;
            border: 1px solid #ddd;
            border-radius: 5px;
            text-align: center;
            background: #ffffff;
          }
        }

        .no-data {
          height: 50px;
          line-height: 50px;
          color: #999999;
          font-size: 20px;
          text-align: center;
          width: 1590px;
          background-color: #f0f0f0;
        }
      }
    }

    .btn-wrapper {
      margin-top: 50px;

      a {
        display: block;
        height: 38px;
        line-height: 38px;
        width: 298px;
        color: #fff;
        font-size: 20px;
        text-align: center;
        background: @blue-d;
        border-radius: 5px;
        margin: 0 auto;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/MyOrderPerson.vue